var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDocumentationinline = function SvgDocumentationinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00877C",
    fillRule: "evenodd",
    d: "M32 64c17.673 0 32-14.327 32-32C64 14.327 49.673 0 32 0 14.327 0 0 14.327 0 32c0 17.673 14.327 32 32 32m-9.692-49.23h22.615c.596 0 1.077.482 1.077 1.077v32.307c0 .595-.481 1.077-1.077 1.077H22.308A4.312 4.312 0 0 1 18 44.923V19.077a4.312 4.312 0 0 1 4.308-4.308M40.615 18H32v11.846l4.308-3.23 4.307 3.23V18M22.308 47.077h21.538V42.77H22.308a2.156 2.156 0 0 0-2.154 2.153c0 1.188.966 2.154 2.154 2.154",
    clipRule: "evenodd"
  })));
};
export default SvgDocumentationinline;